import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import {
  IconButton, getTexts, useTheme, colorShade, contrastColor,
} from '@twnel/web-components';

const HEIGHT = 44;

// Fecha local en el formato de <input type="date">.
const today = () => {
  const date = new Date();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${date.getFullYear()}-${month}-${day}`;
};

const Label = styled.label`
  display: flex;
  align-items: center;
  gap: 0.4rem;
  min-width: 0;
  font-size: 0.82rem;
  color: ${({ theme }) => colorShade(2, theme.foreground)};
`;

const DateField = styled.input`
  min-width: 0;
  height: 1.75rem;
  padding: 0 0.35rem;
  font-family: inherit;
  font-size: 0.82rem;
  color: ${({ theme }) => theme.foreground};
  background-color: ${({ theme }) => theme.background};
  border: thin solid ${({ theme }) => contrastColor(4, theme.background)};
  border-radius: 4px;
  outline: none;
  &:focus {
    border-color: ${({ theme }) => theme.actionable};
  }
`;

const DateRangeBar = ({ dateRange, onChange }) => {
  const theme = useTheme();
  const texts = useSelector(getTexts);
  const { from, to } = dateRange;
  const max = today();

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '0.75rem',
        height: `${HEIGHT}px`,
        padding: '0 0.5rem 0 1rem',
        boxSizing: 'border-box',
        borderBottom: `thin solid ${contrastColor(4, theme.background)}`,
      }}
    >
      <Label>
        {texts('From')}
        <DateField
          type="date"
          aria-label={texts('From')}
          value={from}
          max={to || max}
          onChange={({ target }) => onChange({ from: target.value, to })}
        />
      </Label>
      <Label>
        {texts('To')}
        <DateField
          type="date"
          aria-label={texts('To')}
          value={to}
          min={from || undefined}
          max={max}
          onChange={({ target }) => onChange({ from, to: target.value })}
        />
      </Label>
      <div style={{ flexGrow: 1 }} />
      {from || to ? (
        <IconButton
          aria-label={texts('Clear dates')}
          onClick={() => onChange({ from: '', to: '' })}
        >
          <i className="fas fa-times" />
        </IconButton>
      ) : null}
    </div>
  );
};

DateRangeBar.propTypes = {
  dateRange: PropTypes.shape({
    from: PropTypes.string.isRequired,
    to: PropTypes.string.isRequired,
  }).isRequired,
  onChange: PropTypes.func.isRequired,
};

DateRangeBar.HEIGHT = HEIGHT;

export default DateRangeBar;
